export const demo = {
  siteName: "demo",
  senderName: "War Box Demo",
  logo: "/static/warbox_logo.png",
  name: "War Box Demo",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "demo",
};
